// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style.sass
// module id = 258
// module chunks = 11